export default __webpack_public_path__ + "static/media/grad3.4a2b1db7.png";